import { KeyboardEvent } from 'react';
import Avatar from '../Avatar/Avatar';
import styles from './FeedComposer.module.scss';

export interface FeedComposerCollapsedProps {
  avatarUrl?: string;
  username: string;
  onActivate: () => void;
}

export default function FeedComposerCollapsed({
  avatarUrl,
  username,
  onActivate,
}: FeedComposerCollapsedProps) {
  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onActivate();
    }
  };

  return (
    <div
      className={styles.collapsed}
      role="button"
      tabIndex={0}
      onClick={onActivate}
      onFocus={onActivate}
      onKeyDown={handleKeyDown}
      aria-label="Create a new post"
    >
      <Avatar
        src={avatarUrl}
        username={username}
        size="md"
        className={styles.avatar}
      />
      <span className={styles.placeholder}>What's on your mind?</span>
    </div>
  );
}
